import { ModuleRoute } from 'module-routes';

export enum ElectronicBillingPath {
  Company = 'company',
  ApiKeyClients = 'api-key-clients',
  Documents = 'documents',
  MyDocuments = 'my-documents',
  MySummaries = 'my-summaries',
  MyVoidedDocuments = 'my-voided-documents',
}

export const ElectronicBillingModuleRoutes = new Map<ElectronicBillingPath, <T>(id?: T) => string>([
  [ElectronicBillingPath.Company, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.Company}`],
  [ElectronicBillingPath.ApiKeyClients, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.ApiKeyClients}`],
  [ElectronicBillingPath.Documents, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.Documents}`],
  [ElectronicBillingPath.MyDocuments, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.MyDocuments}`],
  [ElectronicBillingPath.MySummaries, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.MySummaries}`],
  [ElectronicBillingPath.MyVoidedDocuments, () => `${ModuleRoute.ElectronicBilling}/${ElectronicBillingPath.MyVoidedDocuments}`],
]);

export const getElectronicBillingModuleRoutes = <T>(route: ElectronicBillingPath, id?: T): string => {
  const routeFunction = ElectronicBillingModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
